import React, { useEffect, useState, useRef } from "react";
import Highcharts from "highcharts";
import accessibility from "highcharts/modules/accessibility";
import HighchartsReact from "highcharts-react-official";
accessibility(Highcharts);

export default function HighchartsBarChart(props) {
  const [chartWidth, setChartWidth] = useState(200);
  const chartRef = useRef(null);
  
  const handleResize = () => {
    const width =
      document.getElementById("chart-container")?.clientWidth || 200;
    setChartWidth(width);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const options = {
    chart: {
      type: "bar",
      width: chartWidth,
      accessibility: {
        enabled: true, // Enable accessibility features
      },
    },
    title: {
      text: props.label,
    },
    xAxis: {
      categories: props.data.map((d) => d.month),
      labels: {
        rotation: 0,
        maxStaggerLines: 1,
        step: 1,
      },
    },
    yAxis: {
      title: {
        text: props.xlabel,
      },
    },
    series: [
      {
        name: props.xlabel,
        data: props.data.map((d) => d.yValue),
      },
    ],
  };

  return (
    <div className="container-fluid my-5">
      <div className="card shadow-sm p-4">
        <div className="card-body">
          {props.data.length > 0 ? (
            <div id="chart-container" style={{ width: "100%", height: "450px" }}>
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                ref={chartRef}
              />
            </div>
          ) : (
            <p className="text-center py-3">No Data Found</p>
          )}
        </div>
      </div>
    </div>
  );
}
